import React, { Component } from "react";
import moment from 'moment';
import MinistryContactInputForm from "./ministry_contact_input_form";
import { NotificationManager, NotificationContainer } from 'react-notifications';

import { isEmailValid, isNameValid, isStartDateEndDateValid } from './contact_validation';

import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";

const backend = require('../../config.js').backend;


export class NewContact extends Component {

    constructor(props) {
        super(props);

        this.state = {

            newContact: {
                Name: '',
                Email1: '',
                Email2: '',
                Email3: '',
                StartDate: new Date(),
                EndDate: '',
                MinistryID: '',
                Creator: props.creator
            },
            ministries: props.ministries,
            redirectLogout: false

        }

    }


    handleAddNewContact = contact => {


        this.isContactValid(contact)
            .then((isValid) => {
                if (isValid) {
                    this.createContact(contact);
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    isContactValid = contact => {
        var validate = [];

        if (!contact.MinistryID) {
            NotificationManager.error('Please choose a ministry.');
            return false
        }

        validate.push(isNameValid(contact.Name));
        validate.push(isEmailValid(contact.Email1));

        if (contact.Email2 !== '') validate.push(isEmailValid(contact.Email2));

        if (contact.Email3 !== '') validate.push(isEmailValid(contact.Email3));


        validate.push(isStartDateEndDateValid(contact.StartDate, contact.EndDate));

        return new Promise(function (resolve, reject) {

            Promise.all(validate)
                .then((results) => {
                    resolve(true);
                })
                .catch((e) => {
                    NotificationManager.error('Please check your input. ' + e.toString());
                    reject(false);
                });

        });

    }


    // Create Ministry Contact 
    createContact = contact => {

        contact.StartDate = moment(contact.StartDate).format('YYYY-MM-DD');

        if (contact.EndDate === null || contact.EndDate === '' || contact.EndDate === undefined) {
            contact.EndDate = null;
        }
        else {
            contact.EndDate = moment(contact.EndDate).format('YYYY-MM-DD');
        }

        this.addContactToSQL(contact)
            .then(id => {

                this.props.refresh();
                this.props.closePopup();
                NotificationManager.success('Ministry contact is created successfully');

            })
            .catch(err => err);


    }

    addContactToSQL = contact => {

        var that = this;

        return new Promise(function (resolve, reject) {

            var url = `api/v1/ministrycontact`;
            fetch(backend + url, {
                method: 'POST',
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'contact': contact })
            })
                .then(response => response.json())
                .then(data => {

                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    } else {
                        resolve(data);
                    }
                });

        })

    }


    render() {

        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        const { newContact } = this.state;

        let content = (

            <div className='new-ministry-contact'>
                <div className='popup'>

                    <span className="close" onClick={this.props.closePopup}>×</span>

                    <div className='popup_inner'>
                        <div className="table-container2">
                            <h4 className='title'>New Ministry Contact Details</h4>
                            <MinistryContactInputForm
                                contact={newContact}
                                ministries={this.state.ministries}
                                handleSave={this.handleAddNewContact}
                            />

                        </div>

                    </div>
                    <NotificationContainer />

                </div>
            </div>
        )

        return (content)
    }


}


export class EditContact extends Component {

    constructor(props) {
        super(props);

        this.state = {

            ministries: props.ministries,
            contact: props.contact,
            errors: {},
            editor: props.editor

        }

    }


    handleAddNewContact = contact => {

        console.log(contact);

        if (this.isContactValid) {
            this.editContact(contact);
        }
    }

    isContactValid = _ => {
        // const {contact} = this.state;

        return true

    }


    // Create Ministry Contact 
    editContact = contact => {

        console.log('editContact', contact);

        contact.StartDate = moment(contact.StartDate).format('YYYY-MM-DD');

        if (contact.EndDate === null || contact.EndDate === '' || contact.EndDate === undefined) {
            contact.EndDate = null;
        }
        else {
            contact.EndDate = moment(contact.EndDate).format('YYYY-MM-DD');
        }

        this.updateContactInSQL(contact)
            .then(id => {
                console.log(id)
                // console.log('addContactToSQL', id.ContactId);
                this.props.refresh();
                this.props.closePopup();
                NotificationManager.success('Ministry contact is updated successfully');

            })
            .catch(err => err);

    }


    updateContactInSQL = contact => {
        console.log('updateContactInSQL', contact);
        const { editor } = this.state;
        var that = this;

        return new Promise(function (resolve, reject) {

            var url = `api/v1/ministrycontact/` + editor;
            fetch(backend + url, {
                method: 'PUT',
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'contact': contact })
            })
                .then(response => response.json())
                .then(data => {
                    // console.log(data);
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    } else {
                        resolve(data);
                    }
                });

        })

    }


    render() {

        const { contact } = this.state;
        console.log(contact);

        let content = (

            <div className='new-ministry-contact'>
                <div className='popup'>

                    <span className="close" onClick={this.props.closePopup}>×</span>

                    <div className='popup_inner'>
                        <div className="table-container2">
                            <h4 className='title'>Edit Ministry Contact Details</h4>
                            <MinistryContactInputForm
                                contact={this.state.contact}
                                ministries={this.state.ministries}
                                handleSave={this.handleAddNewContact}
                            />
                        </div>
                    </div>

                    <NotificationContainer />

                </div>
            </div>
        )

        return (content)
    }


}